/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React, { CSSProperties } from "react";
import { default as IconBerserkerMail } from "../Icon";

interface IListItemContainer {
  isActive: boolean;
  noOption?: boolean;
}

const ListItemContainer = styled.div<IListItemContainer>`
  border-bottom: 1px solid #d4d4d4;
  border: 1px solid transparent;
  padding: 10px;
  cursor: pointer;
  font-size: 16px;
  z-index: 20;
  display: flex;
  justify-content: space-between;
  background-color: ${(props) => (props.isActive ? "#FFF2E5" : "#fff")};
  color: ${(props) => (props.isActive ? "#fb972e" : "#000")};

  ${(props) =>
    !props.noOption &&
    css`
      :hover {
        background-color: #fff2e5;
        color: #fb972e;
      }
    `}
`;

const ListIconContainer = styled.div`
  margin-right: 10px;
  height: 16px;
`;

const ListItemText = styled.span`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const Row = styled.div`
  overflow-x: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ListSuffixContainer = styled.div`
  color: #999;
`;

interface Props {
  name: string;
  font?: string;
  icon?: string;
  suffix?: string;
  noOption?: boolean;
  isHover: boolean;
  isSelected: boolean;
  alreadyWrittenText: string;
  customStyle?: CSSProperties;
  onClick: () => void;
}

export function SavedSearchItem(props: Props): JSX.Element {
  const { icon, suffix, name, isHover, customStyle, onClick, noOption } = props;

  return (
    <ListItemContainer
      style={customStyle}
      isActive={isHover}
      onClick={onClick}
      noOption={noOption}
    >
      <Row>
        {icon && (
          <ListIconContainer className="icon">
            <IconBerserkerMail
              name={icon}
              height={16}
              width={16}
              color="#999"
            />
          </ListIconContainer>
        )}
        <ListItemText>{name}</ListItemText>
      </Row>

      {suffix && (
        <ListSuffixContainer className="sufix">{suffix}</ListSuffixContainer>
      )}
    </ListItemContainer>
  );
}
